// extracted by mini-css-extract-plugin
export default {"toggleBtn":"ThemeToggler_toggleBtn__jwzl9","iconMoon":"ThemeToggler_iconMoon__Ujy2p"};